import { ProductPageLayout } from '~/components/ProductPageLayout/ProductPageLayout'
import { ProductPage } from '~/components/ProductPage/GreenWallProductPage'
import { GreenWallConfiguration } from '~/components/ProductPage/productTypes/greenwall'

export default function GreenWallConfiguratorPage() {
  return (
    <ProductPageLayout>
      <ProductPage
        components={GreenWallConfiguration}
        name="Rafturi de depozitare pentru plante"
      />
    </ProductPageLayout>
  )
}
